import React, { useContext } from 'react';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Alert, Card, CardContent, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Badge, styled, BadgeProps } from '@mui/material/';
import { blue, red } from '@mui/material/colors';

//components import
import { AuditorCommunicationContext } from '../view-archer';
import ArcherIssue from '../dataObjects/ArcherIssue';
import { InsertCommentOutlined } from '@mui/icons-material';

interface Props {
    delinquentIssues?: ArcherIssue[];
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -3,
        top: 6,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));


const DashboardDelinquentIssues = (props: Props) => {

    //initial state setup
    const context = useContext(AuditorCommunicationContext);

    const setCurrentLetterCpfId = (cpfId: number) => {
        context.setCurrentLetterCpfId(cpfId);
    };

    const calculateDays = (issueDate: string) => {
        let start = new Date(issueDate);
        let end = new Date();
        const timeDiff = end.getTime() - start.getTime();
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        return daysDiff;
    };

    return (
        <div>
            <Card className="dashboard-tile">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container alignContent="center" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="subtitle1" color="blue">Delinquent Audit Issues {props.delinquentIssues && `(${props.delinquentIssues.length})`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {
                                props.delinquentIssues && props.delinquentIssues.length === 0 &&
                                <Alert severity="success" sx={{ margin: 2 }}> There are no delinquent Audit Issues!</Alert>
                            }
                            {
                                props.delinquentIssues && props.delinquentIssues.length > 0 &&
                                <TableContainer sx={{ maxHeight: 265, m: 1 }}>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Filer</TableCell>
                                                <TableCell sx={{ textAlign: "left!important" }}>Issue</TableCell>
                                                <TableCell sx={{width:120}}>Days Open</TableCell>
                                                <TableCell>Responses</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                    props.delinquentIssues?.map((issue) =>
                                                    <TableRow
                                                        key={issue.issueId}
                                                    >
                                                        <TableCell className="is-clickable" onClick={() => setCurrentLetterCpfId(issue.cpfId)}><strong>{issue.cpfId} {issue.filerFullName}</strong></TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" sx={{ color: red[500] }} className="is-clickable issue-link-text" onClick={() => setCurrentLetterCpfId(issue.cpfId)}>
                                                                {issue.issueTypeCode} {issue.header}
                                                                <Typography variant="body2" sx={{ color: blue[500] }}>(<i>sent {issue.date}</i>)</Typography>
                                                            </Typography>
                                                        </TableCell>
                                                            <TableCell sx={{ textAlign: "center!important" }}>
                                                                <Typography variant="body2" className="issue-link-text">{calculateDays(issue.date)}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                                {
                                                                    issue.unreviewedResponses && issue.unreviewedResponses.length > 0 &&
                                                                    <StyledBadge badgeContent={issue.unreviewedResponses.length} color="primary">
                                                                            <InsertCommentOutlined color="action" className="is-clickable" onClick={() => setCurrentLetterCpfId(issue.cpfId)} />
                                                                    </StyledBadge>
                                                                }
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }

                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    )
}

export default DashboardDelinquentIssues;